import { useCallback, useEffect, useState } from 'react'
import { withAttribution } from '@src/functions/attribution'

/**
 * Returns a function that stamps the session's paid-traffic attribution params
 * onto a link into the booking app (see src/functions/attribution.ts).
 *
 * It hands back the URL untouched until after mount. The params live in
 * sessionStorage, which the server cannot see, so rewriting the href during the
 * first render would be a hydration mismatch on a static page.
 */
export default function useAppLink() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return useCallback((url: string) => (mounted ? withAttribution(url) : url), [mounted])
}
